'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseData = exports.generateRoutes = exports.getUser = exports.loginValidate = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _axios = require('@/plugins/axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsBase = require('js-base64');

var _jsMd = require('js-md5');

var _jsMd2 = _interopRequireDefault(_jsMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loginValidate = exports.loginValidate = function loginValidate(_ref, vm) {
  var commit = _ref.commit;

  var pwd = (0, _jsMd2.default)(vm.formInline.password);
  return new _promise2.default(function (resolve, reject) {
    (0, _axios2.default)({
      url: 'user',
      headers: {
        'Authorization': 'Basic ' + _jsBase.Base64.encode(vm.formInline.user + ':' + pwd)
      },
      data: {
        captcha: vm.formInline.vcode
      },
      method: 'GET'
    }).then(function (_ref2) {
      var data = _ref2.data,
          headers = _ref2.headers;

      if (data.authenticated) {
        resolve(data);
        return false;
      }
      reject(data);
    }).catch(function (err) {
      return reject(err);
    });
  });
};
var getUser = exports.getUser = function getUser(_ref3) {
  var commit = _ref3.commit;

  return new _promise2.default(function (resolve, reject) {
    resolve({
      // user: 'lk',
      // password: '888888'
    });
  });
};

var generateRoutes = exports.generateRoutes = function generateRoutes(_ref4) {
  var commit = _ref4.commit;

  return new _promise2.default(function (resolve, reject) {
    resolve({
      // user: 'lk',
      // password: '888888'
    });
  });
};

/**
 * 获取数据字典方法
 */
var getBaseData = exports.getBaseData = function getBaseData(_ref5, baseDataKeys) {
  var commit = _ref5.commit;

  var params = 'typeCodes=' + baseDataKeys.join('&typeCodes=');
  return new _promise2.default(function (resolve, reject) {
    (0, _axios2.default)({
      url: 'api-basic/portal/open/dicttype/listDict?' + params,
      method: 'GET'
    }).then(function (res) {
      if (res.data.code == 2000) {
        var baseDataTypeMap = {};
        res.data.data.forEach(function (typeEle) {
          var baseDataMap = {};
          typeEle.dicts.forEach(function (dataEle) {
            baseDataMap[dataEle.dictCode] = dataEle.dictName;
          });
          baseDataTypeMap[typeEle.dictTypeCode] = baseDataMap;
        });
        baseDataTypeMap.data = res.data;
        resolve(baseDataTypeMap);
      } else {
        reject(res);
      }
    }).catch(function (err) {
      return reject(err);
    });
  });
};